import { INIT, READY, OPEN, CLOSE, DESTROY } from './STATES';

export default (state, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...state,
        loading: true,
        size: action.size,
      };
    }

    case READY: {
      // loading = false when user aborted dynamic load.
      if (!state.loading) {
        return state;
      }
      return {
        ...state,
        component: action.component,
      };
    }

    case OPEN: {
      // closed = true when user aborted dynamic load.
      if (state.closed || !state.component) {
        return state;
      }
      return {
        ...state,
        loading: false,
        open: true,
      };
    }

    case CLOSE:
      // Quick abort.
      if (!state.open) {
        return {
          open: false,
          closed: false,
          loading: false,
        };
      }
      return {
        ...state,
        closed: true,
      };

    case DESTROY:
      return {
        open: false,
        closed: false,
        loading: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/stateful/Modal/reducers.js